module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex agreement"
  }, [_c('div', {
    staticClass: "basic"
  }, [_c('agreement-profile', {
    attrs: {
      "agreement": _vm.agreement,
      "edit_id": _vm.edit_id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-support"
  }, [_c('agreement-pdf', {
    attrs: {
      "agreement": _vm.agreement,
      "edit_id": _vm.edit_id,
      "type": "true"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71b2dfde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Agreement/AgreementIndex.vue
// module id = 1411
// module chunks = 0